export default __webpack_public_path__ + "static/media/starrepair_1.0865c810.jpg";